// Static content data for Vibhuti Logistics site
// Icons are referenced by name (string); resolved via lib/icon.js

export const COMPANY = {
    name: "Vibhuti Logistics",
    tagline: "Customized Logistics Solutions Since 2004",
    subTagline: "Integrated 3PL & 4PL Logistics Solutions for Manufacturing Businesses.",
    founded: 2004,
    address: "Waluj MIDC, Chhatrapati Sambhajinagar (Aurangabad), Maharashtra, India",
    phones: ["+91 80550 55838", "+91 80550 35838"],
    email: "contact@vibhutilogistics.co.in",
    whatsapp: "918055055838",
    socials: {
        linkedin: "#",
        twitter: "#",
        facebook: "#",
    },
};

export const NAV_LINKS = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Services", href: "/services" },
    { label: "Industries", href: "/industries" },
    { label: "Infrastructure", href: "/infrastructure" },
    { label: "Network", href: "/network" },
    { label: "Clients", href: "/clients" },
    { label: "Careers", href: "/careers" },
    { label: "Contact", href: "/contact" },
];

export const TRUST_METRICS = [
    { value: "20+", label: "Years Experience", testId: "metric-years" },
    { value: "100+", label: "Operational Fleet", testId: "metric-fleet" },
    { value: "45+", label: "Industrial Clients", testId: "metric-clients" },
    { value: "150+", label: "Deliveries / Day", testId: "metric-deliveries" },
    { value: "40+", label: "Team Members", testId: "metric-team" },
];

export const PERFORMANCE_COUNTERS = [
    { value: 210000, suffix: "+", label: "Invoices Delivered", testId: "counter-invoices" },
    { value: 47550, suffix: "+", label: "Trips Completed", testId: "counter-trips" },
    { value: 128544, suffix: "+", label: "Metric Tonnes Transported", testId: "counter-tonnes" },
    { value: 2000, suffix: "+", label: "Components Managed", testId: "counter-components" },
];

export const SERVICES = [
    {
        slug: "transportation",
        title: "Transportation",
        icon: "Truck",
        teaser: "FTL, dedicated fleets and route-optimised line-hauls with live GPS visibility.",
        bullets: ["FTL & Dedicated Fleet", "Route Optimization", "Real-time GPS Tracking", "Invoice Traceability"],
        featured: true,
    },
    {
        slug: "warehousing",
        title: "Warehousing",
        icon: "Warehouse",
        teaser: "WMS-led warehousing across Waluj & Chakan with inventory accuracy and dispatch SLAs.",
        bullets: ["Inventory Management", "WMS Integration", "Stock Monitoring", "Dispatch Management"],
        featured: true,
    },
    {
        slug: "distribution",
        title: "Distribution Logistics",
        icon: "Network",
        teaser: "First-mile to last-mile distribution planning across the Pune–Aurangabad corridor.",
        bullets: ["First Mile", "Last Mile", "Distribution Planning"],
    },
    {
        slug: "contract",
        title: "Contract Logistics",
        icon: "Workflow",
        teaser: "Line-feeding, component assembly and embedded inbound–outbound logistics on plant floors.",
        bullets: ["Line Feeding", "Component Assembly", "Inbound Logistics", "Outbound Logistics"],
    },
    {
        slug: "reverse",
        title: "Reverse Logistics",
        icon: "Recycle",
        teaser: "Returns, recovery and material movement managed with full chain-of-custody.",
        bullets: ["Returns Management", "Material Movement", "Recovery Logistics"],
    },
    {
        slug: "3pl",
        title: "3PL Services",
        icon: "Layers",
        teaser: "End-to-end third-party logistics — transportation, warehousing, distribution under one SLA.",
        bullets: ["Integrated SLAs", "Dedicated Team", "Performance Reporting"],
    },
    {
        slug: "4pl",
        title: "4PL Services",
        icon: "Boxes",
        teaser: "Supply chain design, supplier management and orchestration of multi-vendor networks.",
        bullets: ["Supply Chain Design", "Supplier Management", "Performance Measurement", "Risk Mitigation"],
    },
    {
        slug: "scm",
        title: "Supply Chain Management",
        icon: "PackageOpen",
        teaser: "Strategic supply chain consulting for cost-out, JIT supply and inventory turn optimisation.",
        bullets: ["JIT Supply", "Inventory Optimisation", "Cost Engineering"],
    },
];

export const WHY_VIBHUTI = [
    {
        icon: "Satellite",
        title: "Technology Enabled",
        body: "GPS tracking, WMS, MIS reporting and invoice traceability across every consignment.",
    },
    {
        icon: "Warehouse",
        title: "Owned Infrastructure",
        body: "Operational warehouses at Waluj & Chakan with built-to-suit capability up to 120,000 sqft.",
    },
    {
        icon: "Factory",
        title: "Industry Expertise",
        body: "Two decades of automotive, auto-ancillary and engineering manufacturing experience.",
    },
    {
        icon: "ShieldCheck",
        title: "Customer Focused",
        body: "Dedicated team allocation, JIT supply, line feeding and zero-defect dispatch discipline.",
    },
];

export const INDUSTRIES = [
    {
        slug: "automotive",
        title: "Automotive OEM",
        icon: "CarFront",
        body: "Inbound, line-feeding and outbound logistics for OEM plants across the Pune–Aurangabad belt.",
        image: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMHBsYW50JTIwbWFjaGluZXJ5fGVufDB8fHx8MTc4MTc4MzUzNXww&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "auto-components",
        title: "Auto Components",
        icon: "Cog",
        body: "JIT supply for tier-1 and tier-2 ancillaries with 2000+ SKUs under management.",
        image: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1200&q=80",
    },
    {
        slug: "engineering",
        title: "Engineering",
        icon: "Wrench",
        body: "Project cargo, heavy-fab movement and skid logistics for engineering manufacturers.",
        image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80",
    },
    {
        slug: "manufacturing",
        title: "Industrial Manufacturing",
        icon: "Factory",
        body: "Embedded 3PL operations for industrial component and assembly manufacturers.",
        image: "https://images.unsplash.com/photo-1581091870622-1c6a4e1d7c9f?auto=format&fit=crop&w=1200&q=80",
    },
    {
        slug: "power",
        title: "Power & Projects",
        icon: "Zap",
        body: "Heavy-load movement, ODC permits and project-site logistics for power & infrastructure.",
        image: "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1200&q=80",
    },
    {
        slug: "agri",
        title: "Heavy & Agri Machinery",
        icon: "Tractor",
        body: "Bulk machinery movement and dealer-network distribution across Maharashtra & beyond.",
        image: "https://images.unsplash.com/photo-1599420186946-7b6fb4e297f0?auto=format&fit=crop&w=1200&q=80",
    },
];

export const TECH_STACK = [
    { icon: "Satellite", title: "GPS Tracking", body: "Real-time consignment visibility 24×7." },
    { icon: "ServerCog", title: "WMS", body: "Inventory accuracy and slot-level control." },
    { icon: "FileBarChart", title: "MIS Reporting", body: "Daily, weekly and monthly KPI dashboards." },
    { icon: "Radio", title: "Real-Time Monitoring", body: "Geo-fenced ETAs, exception alerts, ePOD." },
];

export const TIMELINE = [
    { year: "2004", title: "Founded", body: "Vibhuti Logistics established at Waluj MIDC, Aurangabad with a focus on automotive transport." },
    { year: "2008", title: "Bajaj Auto Partnership", body: "Began long-term dedicated logistics operations with Bajaj Auto." },
    { year: "2012", title: "Warehousing Foray", body: "Added managed warehousing services with WMS integration." },
    { year: "2016", title: "Chakan Expansion", body: "Opened operations in Chakan, Pune to strengthen the Pune–Aurangabad corridor." },
    { year: "2019", title: "3PL Maturity", body: "Crossed 100+ vehicles, 45+ industrial clients and 150+ daily deliveries." },
    { year: "2022", title: "4PL Capabilities", body: "Expanded into supply chain orchestration with 4PL service offerings." },
    { year: "2026", title: "Vision 2030", body: "On the path to becoming the foremost leader in logistics excellence in western India." },
];

export const LEADERSHIP = [
    {
        name: "Shirish Ansarwadikar",
        role: "Founder & Managing Director",
        bio: "Two decades of operational and strategic leadership across India's industrial logistics sector.",
    },
    {
        name: "Swapnil Ansarwadekar",
        role: "Business Development Director",
        bio: "Drives customer partnerships across automotive, engineering and manufacturing accounts.",
    },
    {
        name: "Operations Leadership",
        role: "Plant & Warehouse Heads",
        bio: "A 40+ member team executing 150+ daily deliveries with discipline and SLA-led ownership.",
    },
];

export const CLIENT_NAMES = [
    "Bajaj Auto", "Mahindra", "Endurance", "Varroc", "Bharat Forge", "JBM Group",
    "Cummins", "Greaves Cotton", "Sterling Tools", "Lumax", "Spicer", "Tata AutoComp",
    "Rane Group", "Sona Comstar", "Anand Group", "Schaeffler", "ZF India", "Continental",
];

export const CASE_STUDIES = [
    {
        title: "Bajaj Auto — 19+ Years of On-Time Logistics",
        client: "Bajaj Auto",
        duration: "2008 — Present",
        highlights: [
            "Dedicated fleet operations across Aurangabad & Chakan plants",
            "SAP Portal, EDI and ASN integration",
            "JIT supply with line-feeding inside plant floor",
            "99%+ on-time delivery against contracted SLAs",
        ],
        body: "A flagship partnership demonstrating Vibhuti's depth in automotive logistics — from inbound vendor consolidation to outbound finished-vehicle dispatch."
    },
];

export const FLEET = [
    { type: "LCV", body: "Light commercial vehicles for milk-run and city distribution.", count: "30+" },
    { type: "MCV", body: "Medium commercial vehicles for inter-plant movement.", count: "25+" },
    { type: "FTL Trucks", body: "Full-truck-load 17-22 ft and 32 ft single/multi-axle trucks.", count: "35+" },
    { type: "Trailers", body: "20 ft / 40 ft trailers for heavy & ODC project cargo.", count: "10+" },
];

export const WAREHOUSES = [
    {
        location: "Waluj MIDC, Chhatrapati Sambhajinagar",
        sqft: "Owned facility",
        body: "Anchor warehouse adjacent to Aurangabad's auto manufacturing belt.",
    },
    {
        location: "Chakan, Pune",
        sqft: "Operational facility",
        body: "Strategic facility serving the Pune automotive cluster and Mumbai corridor.",
    },
    {
        location: "Built-to-Suit",
        sqft: "Up to 120,000 sqft",
        body: "10K / 20K / 30K sqft modular configurations available on dedicated lease.",
    },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxzZW1pJTIwdHJ1Y2slMjBoaWdod2F5JTIwZGF3bnxlbnwwfHx8fDE3ODE3ODM1MzV8MA&ixlib=rb-4.1.0&q=85";
export const WAREHOUSE_IMAGE = "https://images.unsplash.com/photo-1684695749267-233af13276d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxsYXJnZSUyMG1vZGVybiUyMHdhcmVob3VzZSUyMGludGVyaW9yJTIwbG9naXN0aWNzfGVufDB8fHx8MTc4MTc4MzUzNXww&ixlib=rb-4.1.0&q=85";
export const FACTORY_IMAGE = "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMHBsYW50JTIwbWFjaGluZXJ5fGVufDB8fHx8MTc4MTc4MzUzNXww&ixlib=rb-4.1.0&q=85";
export const FLEET_IMAGE = "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzZW1pJTIwdHJ1Y2slMjBoaWdod2F5JTIwZGF3bnxlbnwwfHx8fDE3ODE3ODM1MzV8MA&ixlib=rb-4.1.0&q=85";
export const WAREHOUSE_ALT_IMAGE = "https://images.pexels.com/photos/4481327/pexels-photo-4481327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
